import { useTimer } from "react-timer-hook";

const useCustomTimer = ({
    timer,
    onExpire,
}: {
    timer: number;
    onExpire: () => void;
}) => {
    const addSeconds = (date: Date, seconds: number) => {
        date.setSeconds(date.getSeconds() + seconds);

        return date;
    };

    const date = new Date();

    const newDate = addSeconds(date, timer);

    const { seconds, minutes, pause, resume } = useTimer({
        expiryTimestamp: newDate,
        onExpire: onExpire,
    });

    const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;

    return { formattedTime, seconds, pause, resume };
};

export default useCustomTimer;
